import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import PollConfig from "../../utils/PollConfig";

import { addFlashMessage } from "../../actions/flashMessages";
import {
  nextPollPage,
  cancelConfirmDialog,
  sendForm,
  realSendPoll,
  closeSavingErrorDialog
} from "../../actions/poll";

import PollForm from "../poll/PollForm";
import SavingPollLock from "../poll/SavingPollLock";
import ConfirmSaveDialog from "../poll/ConfirmSaveDialog";
import SavingErrorDialog from "../poll/SavingErrorDialog";

class Poll extends React.Component {
  // flash() {
  //   const { addFlashMessage } = this.props;
  //   addFlashMessage({
  //     type: "success",
  //     text: "TEXT"
  //   });
  // }
  // <Button onClick={this.flash.bind(this)}>Message</Button>
  //

  componentDidMount = () => {
    // ReactDOM.findDOMNode(this).scrollIntoView();
  };

  render() {
    const pageNumber = this.props.page;
    const {
      savingPoll,
      sendFormPressed,
      saveErrorInfo,
      formValues
    } = this.props;
    const config = new PollConfig();
    const page = config.getPage(pageNumber);
    return (
      <div>
        <section className="hero sticky-header">
          <div className="hero-block">
            <div className="hero-body">
              <div className="container">
                <h1 className="title">{page.name}</h1>
                <div className="content is-medium">
                  <h3 className="subtitle">{page.header}</h3>
                </div>
                {page.notes && (
                  <div dangerouslySetInnerHTML={{ __html: page.notes }} />
                )}
              </div>
            </div>
          </div>
        </section>

        <div className="container is-widescreen poll-container">
          <PollForm
            page={pageNumber}
            onSubmit={() => this.props.nextPollPage(formValues)}
          />
        </div>
        <ConfirmSaveDialog
          show={sendFormPressed}
          cancel={this.props.cancelConfirmDialog}
          proceed={this.props.sendForm}
          realSendPoll={this.props.realSendPoll}
          formValues={this.props.formValues}
        />
        <SavingErrorDialog
          show={saveErrorInfo}
          cancel={this.props.closeSavingErrorDialog}
        />
        <SavingPollLock show={savingPoll} />
      </div>
    );
  }
}
Poll.propTypes = {
  page: PropTypes.number.isRequired,
  nextPollPage: PropTypes.func.isRequired,
  savingPoll: PropTypes.bool.isRequired,
  sendFormPressed: PropTypes.bool.isRequired,
  saveErrorInfo: PropTypes.bool.isRequired,
  cancelConfirmDialog: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,
  realSendPoll: PropTypes.func.isRequired,
  formValues: PropTypes.shape(),
  closeSavingErrorDialog: PropTypes.func.isRequired
};
Poll.defaultProps = {
  formValues: {}
};
function mapStateToProps(state) {
  return {
    page: (state.poll && state.poll.page) || 0,
    savingPoll: (state.poll && state.poll.savingPoll) || false,
    saveErrorInfo: (state.poll && state.poll.saveErrorInfo) || false,
    sendFormPressed: (state.poll && state.poll.sendFormPressed) || false,
    formValues: state.form && state.form.pollForm && state.form.pollForm.values
  };
}

export default connect(mapStateToProps, {
  addFlashMessage,
  nextPollPage,
  cancelConfirmDialog,
  sendForm,
  realSendPoll,
  closeSavingErrorDialog
})(Poll);



// WEBPACK FOOTER //
// ./src/components/pages/Poll.js